<template>
    <div class="image-container">
      <img src="../../../../../../../assets/genel/insan_vucudu.jpg" alt="Body Composition" class="image" />
      
      <!-- Sağ ve Sol Bacaklar Yan Yana -->
      <div class="bacak-container">
        <div class="overlay bacak" :style="getOverlayStyle(rightLeg)">
          <div class="text-overlay">
            <h3>Sağ Bacak</h3>
            <p>Yağ Oranı: {{ rightLeg.fat }}%</p>
            <p>Kas Oranı: {{ rightLeg.muscle }}%</p>
            <p>Su Oranı: {{ rightLeg.water }}%</p>
          </div>
        </div>
        <div class="overlay bacak" :style="getOverlayStyle(leftLeg)">
          <div class="text-overlay">
            <h3>Sol Bacak</h3>
            <p>Yağ Oranı: {{ leftLeg.fat }}%</p>
            <p>Kas Oranı: {{ leftLeg.muscle }}%</p>
            <p>Su Oranı: {{ leftLeg.water }}%</p>
          </div>
        </div>
      </div>
  
      <!-- Sağ ve Sol Kol Bilgileri -->
      <div class="kol-container">
        <div class="overlay kol" :style="getOverlayStyle(rightArm)">
          <div class="text-overlay">
            <h3>Sağ Kol</h3>
            <p>Yağ Oranı: {{ rightArm.fat }}%</p>
            <p>Kas Oranı: {{ rightArm.muscle }}%</p>
            <p>Su Oranı: {{ rightArm.water }}%</p>
          </div>
        </div>
        <div class="overlay kol" :style="getOverlayStyle(leftArm)">
          <div class="text-overlay">
            <h3>Sol Kol</h3>
            <p>Yağ Oranı: {{ leftArm.fat }}%</p>
            <p>Kas Oranı: {{ leftArm.muscle }}%</p>
            <p>Su Oranı: {{ leftArm.water }}%</p>
          </div>
        </div>
      </div>
  
      <!-- Gövde ve İç Yağlanma Bilgisi -->
      <div class="overlay body-fat-overlay" :style="getOverlayStyle(bodyAndVisceralFat)">
        <div class="text-overlay">
          <h3>Gövde & İç Yağlanma</h3>
          <p>Yağ Oranı: {{ bodyAndVisceralFat.fat }}%</p>
          <p>Kas Oranı: {{ bodyAndVisceralFat.muscle }}%</p>
          <p>Su Oranı: {{ bodyAndVisceralFat.water }}%</p>
          <p>İç Yağ Oranı: {{ bodyAndVisceralFat.visceralFat }}%</p>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'BodyCompositionOverlay',
    props:{
      pMusteri: Number
    },
    data() {
      return {
        // Sağ Bacak
        rightLeg: { fat: 18, muscle: 32, water: 60, x: 81, y: 75 },
        
        // Sol Bacak
        leftLeg: { fat: 18, muscle: 32, water: 60, x: 20, y: 75 },
  
        // Sağ Kol
        rightArm: { fat: 15, muscle: 30, water: 65, x: 85, y: 25 },
  
        // Sol Kol
        leftArm: { fat: 15, muscle: 30, water: 65, x: 15, y: 25 },
  
        // Gövde ve İç Yağlanma Bilgileri
        bodyAndVisceralFat: {
          fat: 22,
          muscle: 28,
          water: 55,
          visceralFat: 15, // İç yağ oranı
          x: 50,
          y: 55
        }
      };
    },
    methods: {
      getOverlayStyle(area) {
        return {
          top: `${area.y}%`,
          left: `${area.x}%`,
          transform: 'translate(-50%, -50%)',
        };
      },
    },
  };
  </script>
  
  <style scoped>
  .image-container {
    position: relative;
    display: inline-block;
  }
  
  .image {
    width: 100%;
    height: auto;
  }
  
  .bacak-container {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
  
  .bacak {
    position: absolute;
    background: rgba(0, 0, 0, 0.5);
    color: white;
    padding: 10px;
    border-radius: 5px;
    text-align: center;
    width: 40%; /* Bacak kutularını daha küçük yapalım */
  }
  
  .kol-container {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
  }
  
  .kol {
    position: absolute;
    background: rgba(0, 0, 0, 0.5);
    color: white;
    padding: 10px;
    border-radius: 5px;
    text-align: center;
    width: 40%; /* Kol kutularını daha küçük yapalım */
  }
  
  .text-overlay h3 {
    margin: 0;
    font-size: 1.1em;
  }
  
  .text-overlay p {
    margin: 5px 0;
    font-size: 0.9em;
  }
  
  .body-fat-overlay {
    position: absolute;
    background: rgba(0, 255, 0, 0.733); /* Gövde ve İç Yağlanma bilgilerini yeşil yapalım */
    color: white;
    padding: 10px;
    border-radius: 5px;
    text-align: center;
    width: 50%;
  }
  
  .bacak-container .overlay, .kol-container .overlay {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  </style>
  